"use client";

import { getQuizBySlug } from "@/lib/quizzes";
import { getCalculatorBySlug } from "@/lib/calculators";
import { QuizEngine } from "@/components/quiz/QuizEngine";
import { CalculatorForm } from "@/components/calculator/CalculatorForm";

export default function ToolClient({ slug }: { slug: string }) {
  const quiz = getQuizBySlug(slug);
  const calc = getCalculatorBySlug(slug);
  if (quiz) return <QuizEngine quiz={quiz} />;
  if (calc) return <CalculatorForm calc={calc} />;
  return null;
}
